//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux'

//firebase
import { db } from 'assets/firebase';

//
import Parser from 'html-react-parser';

// nodejs library that concatenates classes
import classNames from "classnames";

// styles
import withStyles from "@material-ui/core/styles/withStyles";
import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.jsx";

// core
//import CircularProgress from '@material-ui/core/CircularProgress';

//components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import Quote from "components/Typography/Quote.jsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

//video player
import ReactPlayer from 'react-player'

//icons
import Journal from "@material-ui/icons/FormatQuote";
import Download from "@material-ui/icons/CloudDownload";
import Video from "@material-ui/icons/OndemandVideo";
import Book from "@material-ui/icons/Book";
import Announcement from "@material-ui/icons/Announcement";
import Bullets from "@material-ui/icons/FormatListBulleted";

const dashboardRoutes = [];

function compareGrade(a,b) {

  var aName = a.GradeLevel;
  var bName = b.GradeLevel;

  if (aName < bName)
    return -1;
  if (aName > bName)
    return 1;
  return 0;
}

function compareSortIndex(a,b) {

  var x = Number(a.SortIndex);
  var y = Number(b.SortIndex);

  if (x < y)
    return -1;
  if (x > y)
    return 1;
  return 0;
}

function compareDay(a,b) {

  var aName = a.Day;
  var bName = b.Day;

  if (aName < bName)
    return -1;
  if (aName > bName)
    return 1;
  return 0;
}

class LessonPage extends React.Component {

  constructor(props) {
    super(props);

    this.videoPlayed = this.videoPlayed.bind(this);
    this.saveJournal = this.saveJournal.bind(this);

    this.state = {
      featuredImage: {URL: null},
      video: {URL: null},
      videos: [{URL: null}],
      announcements: [],
      c1: [], c2: [], c3: [], c4: [], c5: [], c6: [], c7: [], c8: [],
      books: [],
      lesson: { Name: "", Attachments:[] },
      className: "",
      opacity: 0,
      journal: { Answer: "" },
      defaultTab: 1,
      showAnnouncements: false
    };

    if(props.classroom) 
      this.state.className = props.classroom.Name;

    var userID, orgID, schoolID, classID = "anonymous";
    if(this.props.user.authenticated) {
      //defaults
      userID = this.props.user.id;
      this.state.userID = userID;

      if(this.props.user.schoolID)
        schoolID = this.props.user.schoolID;
      if(this.props.user.classID)
        classID = this.props.user.classID;
      
      //lesson
      db.getLesson(this.props.match.params.id).then(doc => {
          
          var lesson = doc.data();
          lesson.id = doc.id;
          if(!lesson.Attachments)
              lesson.Attachments = [];
          if(!lesson.Photos)
              lesson.Photos = [];
              
          this.state.lesson = lesson;

          db.getVideosByQuarterAndWeek(this.state.lesson.Quarter, this.state.lesson.Week).then(videos => {
          
            var announcements = [];
            var insights = [];

            for(var i = 0; i < videos.length; i++) {
              if(videos[i].Type === 'Announcement')
                announcements.push(videos[i]);
              else if (videos[i].Type === 'Insight')
                insights.push(videos[i]);
            }

            insights.sort(compareGrade);
            announcements.sort(compareDay);

            this.setState({videos: insights, announcements: announcements});

            if(announcements.length > 0)
              this.setState({defaultTab: 0, showAnnouncements: true});

          });
        
          for(var j = 0; j < this.state.lesson.Photos.length; j++) {
            if(this.state.lesson.Photos[j].isCover) { 
                this.state.featuredImage = this.state.lesson.Photos[j];
                this.state.opacity = 1;
                break;
            }
          }

          var c1 = [];
          var c2 = [];
          var c3 = [];
          var c4 = [];
          var c5 = [];
          var c6 = [];
          var c7 = [];
          var c8 = [];

          for(var k = 0; k < this.state.lesson.Attachments.length; k++) {

            var audience = this.state.lesson.Attachments[k].Audience;
            if(audience === 'all' || 
              audience === 'student' ||
              audience === this.props.user.userType ||
              ((audience === 'teacher' || audience === 'student') && this.props.userType === 'principal' ) ||
              this.props.user.userType === 'admin') {

              if(this.state.lesson.Attachments[k].Category === 'sink')
                c1.push(this.state.lesson.Attachments[k]);
              else if(this.state.lesson.Attachments[k].Category === 'cement')
                c2.push(this.state.lesson.Attachments[k]);
              else if(this.state.lesson.Attachments[k].Category === 'quick')
                c3.push(this.state.lesson.Attachments[k]);
              else if(this.state.lesson.Attachments[k].Category === 'revisit')
                c4.push(this.state.lesson.Attachments[k]);
              else if(this.state.lesson.Attachments[k].Category === 'k1')
                c5.push(this.state.lesson.Attachments[k]);
              else if(this.state.lesson.Attachments[k].Category === '2-3')
                c6.push(this.state.lesson.Attachments[k]);
              else if(this.state.lesson.Attachments[k].Category === '4-5')
                c7.push(this.state.lesson.Attachments[k]);
              else if(this.state.lesson.Attachments[k].Category === '6-8')
                c8.push(this.state.lesson.Attachments[k]);
              
            }
          }
          
          c1.sort(compareSortIndex);
          c2.sort(compareSortIndex);
          c3.sort(compareSortIndex);
          c4.sort(compareSortIndex);
          c5.sort(compareSortIndex);
          c6.sort(compareSortIndex);
          c7.sort(compareSortIndex);
          c8.sort(compareSortIndex);

          this.setState({c1:c1, c2:c2, c3:c3, c4:c4, c5:c5, c6:c6, c7:c7, c8:c8});

          // temp
          this.setState({opacity:1})
      });  

      //journal
      db.getJournalByLessonAndUser(userID, this.props.match.params.id).then(snapshot => {
        
        snapshot.forEach((doc) => {
          var journal = doc.data();
          journal.id = doc.id;
          this.setState({journal: journal}, () => {
            console.log(this.state.journal.Answer);
          });
          
        });
      });

      db.logActivity(userID, orgID, schoolID, classID, "Lesson-Viewed", this.state.lesson.id);

    }
  }

  trim(value, maxLength) {
    if(value) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    } 
  }

  lessonText() {
    if(this.state.lesson.Content)
      return Parser(this.state.lesson.Content);
    else 
      return "";
  }

  bookListText() {
    if(this.state.lesson.BookList)
      return Parser(this.state.lesson.BookList);
    else 
      return "";
  }

  videoPlayed() {
    db.logActivity(this.props.user.id, this.props.org.id, this.props.user.schoolID, this.props.user.classID, "Video-Played");
  }

  hideContentTab () {
    var hideContent = true;
    if(this.state.lesson.Content) {
      if(this.state.lesson.Content !== "") {
        hideContent = false;
      }
    }
    return hideContent;
  }

  getAnnouncements() {

    console.log('getAnnouncements()');

    var gridItems = [];
    for(var i = 0; i < this.state.announcements.length; i++) {
      var label = this.state.announcements[i].Day;
      if(this.state.announcements[i].Day === 1)
        label = "Monday";
      else if(this.state.announcements[i].Day === 2)
        label = "Tuesday";
      else if(this.state.announcements[i].Day === 3)
        label = "Wednesday";
      else if(this.state.announcements[i].Day === 4)
        label = "Thursday";
      else if(this.state.announcements[i].Day === 5)
        label = "Friday";

      var gridItem = 
          
            <GridItem xs={4} key={i} style={{height:"217px", textAlign:"center", marginBottom:"23px"}}>
              <ReactPlayer url={this.state.announcements[i].URL} onStart={this.videoPlayed} controls={true} width='100%' height='100%' />
              {label}
            </GridItem>  
        
      ;
      gridItems.push(gridItem);
    }

    return gridItems;
  }

  getVideoTabs() {

    var tabs = [];
    console.log(this.state.videos)
    for(var i = 0; i < this.state.videos.length; i++) {
      var tabName = "Grades " + this.state.videos[i].GradeLevel;
      if(this.state.videos[i].GradeLevel === '0-1')
        tabName = "Grades K-1";

      var tab = {
        tabName: tabName,
        tabIcon: Video,
        tabContent: (
          
            <div style={{height:"534px"}}>
              <ReactPlayer url={this.state.videos[i].URL} onStart={this.videoPlayed} controls={true} width='100%' height='100%' />
            </div>  
        )
      };
      tabs.push(tab);
    }

    return tabs;
  }

  getClassDescription() {
    return this.state.className + ", Quarter: " + this.state.lesson.Quarter + ", Week: " + this.state.lesson.Week; 
  }

  showQuarterWeek() {
    if(this.state.lesson.Quarter) {
      return "block";
    } else {
      return "none";
    }
  }

  updateJournal(property, value) {
    var journal = this.state.journal;
    journal[property] = value;
    this.setState({journal: journal});
  }

  saveJournal() {
    var journal = this.state.journal;
    journal.UserID = this.state.userID;
    journal.LessonID = this.state.lesson.id;
    journal.modified = Math.round((new Date()).getTime() / 1000);

    db.updateJournal(journal.id, journal).then(doc => {
      
    });
  }

  download(file) {
    
    const start = file.URL.lastIndexOf('/') + 1;
    const length = file.URL.indexOf('?') - start;
    var fileName = file.URL.substr(start, length);
    fileName = fileName.substr(14); // getting rid of "attachments%2F"
    
    var url = "https://us-central1-keiki-262db.cloudfunctions.net/downloadAttachment?fileName=" + fileName;

    window.open(url);
  }

  getAttachmentCategory(audience) {
    if(audience === 'sink')
      return "Introduce It";
    else if(audience === 'cement')
      return "Cement It";
    else if(audience === 'quick')
      return "Quick Cement";
    else if(audience === 'revisit')
      return "Revisit It";
  }

  showCategory(category) {
    if(category.length > 0)
      return "block";
    else
      return "none";
  }

  render() {
    const { classes, ...rest } = this.props;
  
    if (!this.props.user) {
      return <Redirect to='/login' />
    } else if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    } 

    return (
      <div>
        <div style={{opacity:this.state.opacity,transition:"opacity 1s"}}>
          <Header
            color="transparent"
            routes={dashboardRoutes}
            brand="All Things EQ"
            links={<HeaderLinks />}
            fixed
            changeColorOnScroll={{
              height: 200,
              color: "dark"
            }}
            {...rest}
          />
          
          <Parallax image={this.state.featuredImage.URL}>
            
          </Parallax>
          <div className={classNames(classes.main, classes.mainRaisedHigh)} style={{marginLeft: "10px", marginRight:"10px", borderRadius:"6px", backgroundColor:"#efefef", marginTop:"-269px"}}>
              <div className={classes.container} style={{color:"black"}}>
                <div className={classes.section} >
                    
                    <GridContainer justify="center" >
                        <GridItem xs={12} sm={12} md={12}>
                            
                            <br />
                            <h2 className={[classes.title, classes.black]}>{this.state.lesson.Name}</h2>
                            <div style={{color:"#696969",fontSize:"13px", display:this.showQuarterWeek()}}>
                              Quarter: {this.state.lesson.Quarter}, Week: {this.state.lesson.Week}
                            </div><br />
                            <div className={classes.black}>
                              {this.state.lesson.Description}
                            </div>

                            <CustomTabs
                              headerColor="warning"
                              tabs={this.getVideoTabs()}
                            />
                            
                            <div style={{marginTop:"17px"}}>
                              {this.lessonText()}
                            </div>
                            <div style={{marginTop:"89px"}}>

                            <CustomTabs
                              headerColor="warning"
                              value={1}
                              tabs={[
                                {
                                  tabName: "Morning Announcements",
                                  tabIcon: Announcement,
                                  tabHidden: false,
                                  tabContent: (
                                    <GridContainer style={{marginTop:"23px"}}>
                                      {this.getAnnouncements()}
                                    </GridContainer>
                                  )
                                },
                                {
                                  tabName: "Weekly Support",
                                  tabIcon: Bullets,
                                  tabContent: (
                                    <GridContainer direction="row" style={{minHeight:"123px", padding:"20px"}}>
                                      
                                      <h4>INTRODUCE IT</h4>

                                      <Table className={classes.table}>
                                        <TableBody>
                                          <TableRow>
                                            <TableCell>
                                              Write/post the motto: "{this.state.lesson.Name}"
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell>
                                              Play the weekly video!
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell>
                                              Play the daily morning announcement.
                                            </TableCell>
                                          </TableRow>
                                          {this.state.c1.map((attachment,index) => (
                                          <TableRow key={index} className={classes.tableRow}>
                                            <TableCell className={classes.tableActions}>
                                              - {attachment.Name}
                                              <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                  <Download />
                                                </IconButton>
                                              </Tooltip>
                                            </TableCell>
                                          </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>

                                      <div style={{width:"100%", display:this.showCategory(this.state.c2)}}>

                                        <h4 style={{marginTop:"50px"}}>CEMENT IT</h4>

                                        <Table className={classes.table}>
                                          <TableBody>
                                            {this.state.c2.map((attachment,index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                              <TableCell className={classes.tableActions}>
                                                {attachment.Name}
                                                <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                  <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                    <Download />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </div>

                                      <div style={{width:"100%", display:this.showCategory(this.state.c3)}}>

                                        <h4 style={{marginTop:"50px"}}>QUICK CEMENT</h4>

                                        <Table className={classes.table}>
                                          <TableBody>
                                            {this.state.c3.map((attachment,index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                              <TableCell className={classes.tableActions}>
                                                {attachment.Name}
                                                <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                  <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                    <Download />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                      </div>

                                      <div style={{width:"100%", display:this.showCategory(this.state.c4)}}>

                                        <h4 style={{marginTop:"50px"}}>REVISIT</h4>

                                        <Table className={classes.table}>
                                          <TableBody>
                                            {this.state.c4.map((attachment,index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                              <TableCell className={classes.tableActions}>
                                                {attachment.Name}
                                                <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                  <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                    <Download />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                      </div>
                                      <div style={{width:"100%", display:this.showCategory(this.state.c5)}}>

                                        <h4 style={{marginTop:"50px"}}>GRADES K-1</h4>

                                        <Table className={classes.table}>
                                          <TableBody>
                                            {this.state.c5.map((attachment,index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                              <TableCell className={classes.tableActions}>
                                                {attachment.Name}
                                                <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                  <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                    <Download />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                      </div>
                                      <div style={{width:"100%", display:this.showCategory(this.state.c6)}}>

                                        <h4 style={{marginTop:"50px"}}>GRADES 2-3</h4>

                                        <Table className={classes.table}>
                                          <TableBody>
                                            {this.state.c6.map((attachment,index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                              <TableCell className={classes.tableActions}>
                                                {attachment.Name}
                                                <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                  <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                    <Download />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                      </div>
                                      <div style={{width:"100%", display:this.showCategory(this.state.c7)}}>

                                        <h4 style={{marginTop:"50px"}}>GRADES 4-5</h4>

                                        <Table className={classes.table}>
                                          <TableBody>
                                            {this.state.c7.map((attachment,index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                              <TableCell className={classes.tableActions}>
                                                {attachment.Name}
                                                <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                  <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                    <Download />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                      </div>
                                      <div style={{width:"100%", display:this.showCategory(this.state.c8)}}>

                                        <h4 style={{marginTop:"50px"}}>GRADES 6-8</h4>

                                        <Table className={classes.table}>
                                          <TableBody>
                                            {this.state.c8.map((attachment,index) => (
                                            <TableRow key={index} className={classes.tableRow}>
                                              <TableCell className={classes.tableActions}>
                                                {attachment.Name}
                                                <Tooltip id="tooltip-top" title="Download" placement="top" classes={{ tooltip: classes.tooltip }} >
                                                  <IconButton aria-label="Download" className={classes.tableActionButton} onClick={() => this.download(attachment)} >
                                                    <Download />
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                            </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>

                                      </div>

                                    </GridContainer>
                                  )
                                },
                                {
                                  tabName: "Book List",
                                  tabIcon: Book,
                                  tabContent: (
                                    <div style={{marginTop:"23px"}}>
                                      {this.bookListText()}
                                    </div>
                                  )
                                },
                                {
                                  tabName: "e-Journal",
                                  tabIcon: Journal,
                                  tabHidden: true,
                                  tabContent: (
                                    
                                      <GridContainer direction="row">
                                        <GridItem xs={12} sm={12} >
                                          <div style={{fontSize:"15px", marginBottom:"17px"}}>
                                            {this.state.lesson.Questions}
                                          </div>
                                          <CustomInput labelText="Type your answer here." id="answer"
                                            value={this.state.journal.Answer}
                                            inputProps={{ placeholder: "Take your time..", multiline:true }}
                                            formControlProps={{ fullWidth: true }}
                                            onChange={(e) => this.updateJournal("Answer", e.target.value)}
                                          />
                                          <Button color='warning' onClick={this.saveJournal}>Save</Button>     
                                        </GridItem>
                                        
                                      </GridContainer>
                                  )
                                },
                                ]}
                              />
                            </div>
                            <div style={{marginTop:"54px", display:"none"}}>
                              <Quote style={{fontSize:"34px"}}
                                text={this.state.lesson.Quote}
                                author={this.state.lesson.Attribution}
                              />
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
              </div>
            </div>
          

          <Footer content={
            <div>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://app.allthingseq.com/"
                      className={classes.block}
                    >
                      All Things E.Q.
                    </a>
                  </ListItem>
                  
                </List>
              </div>
              <div className={classes.right} style={{fontSize:"12px", marginRight:"23px"}}>
                &copy; {1900 + new Date().getYear()}{" "}
                AVA School Solutions
              </div>
            </div>
          }/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

LessonPage = connect(mapStateToProps)(LessonPage);
export default withStyles(landingPageStyle)(LessonPage);



// WEBPACK FOOTER //
// ./src/views/LessonPage/LessonPage.jsx